<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">
        {{label}}
        <v-icon
            v-if="help_text && help_text != ''"
            right
            style="pointer-events: auto;"
            v-on:click="onClickShowHelpText()"
        >
            mdi-information-outline
        </v-icon>
    </v-card-title>

    <v-card-text>
        
        <v-form
            v-model="valid"
        >

        <m-text-field
            :label="label"
            v-model="value"
            autofocus
            :rules="rules"
            :hint="hint"
            @keydown.enter="$event.preventDefault(); onOk();"
            ref="my_field"
            emoji
        />
            
        </v-form>

    </v-card-text>

    <v-card-actions>
        <v-btn
            v-if="unset_label != null"
            text
            v-on:click="onClickUnset"
        >
            {{unset_label}}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        rules: {
            type: Array,
            default: function () { return []; },
        },

        unset_label: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
            label: 'field',
            value: '',
            valid: false,
            hint: null,
            help_text: null,
            picker_style: null,
        }
    },

    methods: {
        showDialog(label, value, hint, help_text)
        {
            this.label = label;
            this.value = value;
            this.dialog = true; 
            this.hint = hint;
            this.help_text = help_text;
        },

        onClickShowHelpText()
        {
            this.$rc.alert('Additional Information', this.help_text);
        },
        
        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.value);
        },

        onClickUnset()
        {
            this.dialog = false;
            this.$emit('ok',null);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>